module.exports = __webpack_public_path__ + "img/em_mockup_00b.b0613a6e.png";